export const whitelabelConfig = {
  short: 'ooesb',
  assetUrl: '/whitelabel/ooesb/',
  iconUrl: '/img/icons/ooesb/',
  storeName: 'OÖ Seniorenbund Online Store',
  company: 'we-are.travel GmbH',
  analyticsId_ua: 'UA-156259931-6', //old ua
  analyticsId: 'G-54YMWKJPG0', //ga4
  analyticsType: 'gtag', //should be 'gtag', 'ua' or 'both'
  logoHeader:
    'https://assets.urlaubsgutschein.kaufen/whitelabel/ooesb/ooesb-logo.png',
  logoFooter:
    'https://assets.urlaubsgutschein.kaufen/whitelabel/ooesb/ooesb-logo.png',
  // logoHeader: () => require('@/assets/ooesb-logo.png'),
  // logoFooter: () => require('@/assets/ooesb-logo.png'),
  isStandalone: false,
  showHeader: true,
  showHeaderLogo: false,
  showFooterLogo: false,
  fixedNavbar: false,
  heroTitle: 'Urlaubsgutscheine',
  hasHeroSubtitle: true,
  heroSubtitle: 'clever & günstig mit Urlaubsgutschein',
  supportMail: 'urlaubsgutschein@reise-aktiv.at',
  supportPhone: '+43 732 60 05 36',
  hasHeroAddition: false,
  showPromoNotification: false,
  showReduction: true,
  hasCookieConsent: false,
  hasNewsletterOptin: false,
  campaignsEnabled: true,
  heroImageResolution: {
    xl: {width: 2560, height: 500, crop: 'smart'},
    l: {width: 1200, height: 500, crop: 'smart'},
    m: {width: 1024, height: 500, crop: 'smart'},
    s: {width: 960, height: 300, crop: 'east'},
    xs: {width: 700, height: 200, crop: 'centre'},
  },
  hasOfferCta: true,
  hide5sup: true,
  heroInfoText: 'Sparen Sie bis zu 70% für Ihren Kurzurlaub.',
  homepage: {
    advantages: false,
  },
  styleOverride: () =>
    import(
      /* webpackPrefetch: true */

      /* webpackPreload: true */ '@/styles/styles-ooesb.scss'
    ),
}
